export class ApiError extends Error {
  public readonly status: number;
  public readonly code: string | null;

  constructor(message: string, status: number, code: string | null = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

export class FieldsError extends ApiError {
  public fields: Record<string, string>;

  constructor(error: { message: string; code?: string; fields: Record<string, string> }) {
    super(error.message, 400, error.code || null);

    this.name = 'FieldsError';
    this.fields = error.fields;
  }
}

export class ForbiddenError extends ApiError {
  constructor(message: string, code: string | null = null) {
    super(message, 403, code);
    this.name = 'ForbiddenError';
  }
}

export class StreamVendorError extends ApiError {
  constructor(message: string, status: number = 500, code: string | null = null) {
    super(message, status, code);
    this.name = 'StreamVendorError';
  }
}
